var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg117(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2525_2260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 48C28.894 48 28 47.106 28 46V30C28 28.896 27.104 28 26 28H20C18.896 28 18 28.896 18 30V46C18 47.106 17.106 48 16 48C14.894 48 14 47.106 14 46V30C14 26.692 16.692 24 20 24H26C29.308 24 32 26.692 32 30V46C32 47.106 31.106 48 30 48Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 48H4C1.794 48 0 46.206 0 44V22C0 18.692 2.692 16 6 16H12C15.308 16 18 18.692 18 22V44H28V38C28 34.692 30.692 32 34 32H40C43.308 32 46 34.692 46 38V44C46 46.206 44.206 48 42 48ZM32 44H42V38C42 36.896 41.104 36 40 36H34C32.896 36 32 36.896 32 38V44ZM6 20C4.896 20 4 20.898 4 22V44H14V22C14 20.898 13.104 20 12 20H6Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0022 24C39.3562 24 38.7202 23.688 38.3362 23.11C37.7222 22.192 37.9702 20.948 38.8902 20.336L43.2282 17.444L40.3342 13.09C39.7222 12.17 39.9722 10.928 40.8922 10.316C41.8142 9.706 43.0542 9.954 43.6662 10.874L47.6662 16.892C48.2782 17.81 48.0282 19.052 47.1102 19.664L41.1102 23.664C40.7682 23.892 40.3822 24 40.0022 24Z",
    fill: "#DB2A12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5022 20C45.4222 20 45.3422 19.996 45.2622 19.986C32.8522 18.492 21.8542 12.91 12.5682 3.396C11.7962 2.606 11.8122 1.34 12.6042 0.568001C13.3922 -0.199999 14.6582 -0.187999 15.4322 0.604001C24.0622 9.446 34.2602 14.632 45.7382 16.016C46.8362 16.148 47.6162 17.144 47.4862 18.24C47.3642 19.254 46.5002 20 45.5022 20Z",
    fill: "#DB2A12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2525_2260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg117);
export default __webpack_public_path__ + "static/media/svg117.65d5e169d9ba4f9e1b8e7573f2c82daa.svg";
export { ForwardRef as ReactComponent };